/**
 * Removes all properties from object with null value
 *
 * @param {Object} object
 */
export default object => Object.keys(object).forEach(k => (object[k] === null) && delete object[k])